<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: "brand",
  data() {
    return {};
  },
  created() {}
};
</script>
